import React, {Component, Fragment} from 'react';
import Pagination from "../../components/Pagination";
import NewsItem from './NewsItem';


class NewsContent extends Component {

    constructor(props) {
        super(props);
      
        this.state = {
            posts: props.data,
            currentPage: 1,
            postsPerPage: 6
        };
      }

    state = {
        posts: [],
        currentPage: 1,
        postsPerPage: 6
    };

    render() {
        const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.state.posts.slice(indexOfFirstPost, indexOfLastPost);

        const paginate = currentPage => this.setState({
            currentPage: currentPage
        });


        return (
            <div className='col-12'>
                <Fragment>
                    <div className='blog-content-wrapper'>
                        <div className="row mtn-30">
                           
                                {
                                    currentPosts.map(news => (
                                        <NewsItem
                                        key={news.id}
                                        id={news.id}
                                        thumb={news.bag.contentItems[0].image.urls[0]}
                                        title={news.displayText}
                                        excerpt={news.newsOverview}                                       
                                        date={news.newsDate}
                                        detail = {this.state.posts}
                                        />
                                    ))

                                }

                        </div>
                    </div>

                    <Pagination
                        productsPerPage={this.state.postsPerPage}
                        total={this.state.posts.length}
                        paginate={paginate}
                        currentPage={this.state.currentPage}
                    />
                </Fragment>
            </div>
        );
    }
}

export default NewsContent;